/**
 * NO DATA, never 0.
 *
 * A measured zero and an absent measurement are different facts. Rendering an
 * unmeasured metric as "0" implies we looked and found nothing, which is a lie
 * the whole platform is built to avoid.
 */
export function NoData(): JSX.Element {
  return <span className="kpi-value nodata">NO DATA</span>;
}

export function EmptyState({
  title,
  children,
  tag = 'No data yet',
}: {
  title: string;
  children: React.ReactNode;
  tag?: string;
}): JSX.Element {
  return (
    <div className="empty">
      <div className="empty-tag">{tag}</div>
      <h2>{title}</h2>
      <p>{children}</p>
    </div>
  );
}
